import type {
    Component,
} from "vue";
import type {
    RouteRecordRaw,
} from "vue-router";
import {
    createVuePublicRoutes,
} from "@logscord/public-site/adapters/vue";
import type {
    LogscordPublicComponentId,
} from "@logscord/public-site-config";
import {
    PublicSite,
} from "./publicSite.js";


//////////////////////////////////////////////////
//  SHARED PUBLIC VUE ROUTES
//////////////////////////////////////////////////


export function createLogscordHydrationRoutes(
    options: {
        components       : Partial<Record<LogscordPublicComponentId, Component>>;
        target?          : "browser-public" | "public-ssr";
        includeRedirects?: boolean;
    },
): RouteRecordRaw[] {
    const target = options.target ?? "browser-public";

    return createVuePublicRoutes({
        site              : PublicSite,
        components        : options.components,
        target,
        includeRoute      : (definition) => target === "browser-public"
            || definition.access === "public",
        routeMeta         : ({ definition, localized, usesBrowserComponent }) => ({
            requireLogin    : usesBrowserComponent || definition.access === "authenticated",
            publicLocalized : localized && definition.access === "public",
        }),
        includeRedirects: options.includeRedirects,
    });
}

export function createLogscordNotFoundRoute(component: Component): RouteRecordRaw {
    return {
        path      : "/:pathMatch(.*)*",
        component,
        meta: {
            requireLogin : false,
            notFound     : true,
        },
    };
}
